import { render, staticRenderFns } from "./ContactPrefs.vue?vue&type=template&id=4e28bed2&"
import script from "./ContactPrefs.vue?vue&type=script&lang=js&"
export * from "./ContactPrefs.vue?vue&type=script&lang=js&"
import style0 from "./ContactPrefs.vue?vue&type=style&index=0&id=4e28bed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports